const getAllergensContainedPerItem = (allergens = [], currentItemAllergens = []) => {
  const allergensPresentInCurrentItem = currentItemAllergens?.filter(({ requirementId }) =>
    allergens.includes(requirementId),
  );

  return allergensPresentInCurrentItem;
};

export default getAllergensContainedPerItem;
